import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

const initialState = {};

export const userOptionGet = createAsyncThunk('agent-performance/user', async () => {
  return await apiInstance.get('/user');
});

export const dailyAgentReportGet = createAsyncThunk(
  'agent-performance/agent_login_logout',
  async (params) => {
    return await apiInstance.get('/agent_login_logout', { params });
  }
);

export const agentReportDetailsGet = createAsyncThunk(
  'agent-performance/agent_login_logout/details',
  async (params) => {
    return await apiInstance.get('/agent_login_logout/details', { params });
  }
);

export const recordingDownload = createAsyncThunk(
  'download/recording_download/date_wise',
  async (payload) => {
    return await apiInstance.post('/recording_download/date_wise', payload, {
      responseType: 'blob'
    });
  }
);

const agentPerformanceSlice = createSlice({
  name: 'agentPerformance',
  initialState,
  reducers: {
    clearAgentPerformanceSlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default agentPerformanceSlice.reducer;
export const { clearAgentPerformanceSlice } = agentPerformanceSlice.actions;
